import { InfoOutlined as InfoOutlinedIcon, ModeEditOutlined as ModeEditOutlinedIcon } from 'components/icons';
import EditableTextField from 'components/forms/inputs/EditableTextField';
import { Tooltip } from 'components/ui/tooltip';
import React from 'react';
import { useUpdateMatterSequenceNumberMutation } from 'store/api/matters';
import { t } from 'utils/getTranslations';

interface EditableMatterSequenceNumberProps {
    matterId: number;
    clientMatterSequence: number | null | undefined;
}

const EditableMatterSequenceNumber: React.FC<EditableMatterSequenceNumberProps> = ({
    matterId,
    clientMatterSequence,
}) => {
    const [updateMatterSequenceNumber] = useUpdateMatterSequenceNumberMutation();

    const handleSave = async (newValue: string) => {
        await updateMatterSequenceNumber({
            id: matterId,
            value: newValue,
        }).unwrap();
    };

    const validate = (value: string): string | true => {
        if (!/^\d+$/.test(value)) {
            return t('matters.seq-nr-invalid');
        }
        return true;
    };

    const editAndInfoIcons = (
        <div className="text-grey-500 inline-flex items-center gap-1">
            <ModeEditOutlinedIcon className="text-[16px]" />
            <Tooltip content={t('matters.seq-nr-info')}>
                <InfoOutlinedIcon onClick={(e) => e.stopPropagation()} className="text-[16px]" />
            </Tooltip>
        </div>
    );

    return (
        <EditableTextField
            placeholder={'-'}
            value={clientMatterSequence != null ? String(clientMatterSequence) : ''}
            onSave={handleSave}
            isEditEnabled={true}
            validation={validate}
            icon={editAndInfoIcons}
        />
    );
};

export default EditableMatterSequenceNumber;
